export function processJson(raw: string): any {
  try {
    return JSON.parse(raw)
  } catch (error) {
    return null
  }
}
